import Styles from './styles.module.css';
import React from 'react'

type RecruitEditBackProps = {
  backCaution: number;
  setBackCaution: React.Dispatch<React.SetStateAction<number>>;
  setNavigation: React.Dispatch<React.SetStateAction<number>>;
  setChangeData: React.Dispatch<React.SetStateAction<boolean>>;
  resetToSaved: () => void;
};

const RecruitEditBack: React.FC<RecruitEditBackProps> = ({ backCaution, setBackCaution, setNavigation, setChangeData, resetToSaved }) => {

  return (
    <div className={Styles.overlay}>
      <div className={Styles.scrim} onClick={() => setBackCaution(0)}></div>
      <div className={Styles.card}>
        <h4 className={Styles.title}>編集箇所が保存されていません。</h4>
        <p className={Styles.lead}>
          保存せずに画面を終了した場合、編集記録は残りませんので今一度ご確認ください。
        </p>
        <div className={Styles.actions}>
          <button
            type="button"
            className={Styles.btnGhost}
            onClick={() => { resetToSaved(); setNavigation(backCaution); setBackCaution(0); setChangeData(false); }}
          >保存しない</button>
          <button
            type="button"
            className={Styles.btnPrimary}
            onClick={() => setBackCaution(0)}
          >戻る</button>
        </div>
      </div>
    </div>
  );
}

export default RecruitEditBack;
